var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.446 17.5536C79.042 -5.85003 40.9595 -5.85234 17.5536 17.5536C-5.85234 40.9595 -5.85003 79.0397 17.5536 102.446C40.9572 125.851 79.0397 125.851 102.446 102.446C125.849 79.0397 125.849 40.9572 102.446 17.5536ZM83.671 83.671C81.8679 85.4741 78.945 85.4741 77.1419 83.671L59.9996 66.5287L42.0423 84.486C40.2391 86.2891 37.3163 86.2891 35.5132 84.486C33.7101 82.6828 33.7101 79.76 35.5132 77.9569L53.4705 59.9996L36.3282 42.8572C34.525 41.0541 34.525 38.129 36.3282 36.3282C38.1313 34.525 41.0541 34.525 42.8572 36.3282L59.9996 53.4705L76.3246 37.1454C78.1277 35.3423 81.0506 35.3423 82.8537 37.1454C84.6568 38.9486 84.6568 41.8714 82.8537 43.6745L66.5287 59.9996L83.671 77.1419C85.4741 78.945 85.4741 81.8679 83.671 83.671Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d425fe6a3804833414b8c7b5fafc254c.svg";
export { ForwardRef as ReactComponent };